'use client';

import { action, makeObservable, observable } from 'mobx';

export class GovernanceStore {
  stages: string[] = [];

  constructor() {
    makeObservable(this, {
      stages: observable,
      setStages: action.bound,
    });
  }

  setStages(value: string[]) {
    this.stages = value;
  }
}

export const governanceStore = new GovernanceStore();
